import { ALL_KNOWN_DETAILS_TESTIDS, SOURCE_LABEL_SEPARATOR } from '../../constants';
import { labelFor, subLabelFor } from '../../utils/allKnownDetailsUtils';
import type { KnownDetailType, KnownEntityType, KnownSourceGroup, KnownValue } from '../../types';
import SourceValueRow from '../SourceValueRow/SourceValueRow';
import styles from './SourceGroupRow.module.scss';

interface SourceGroupRowProps {
    group: KnownSourceGroup;
    type: KnownDetailType;
    entityType: KnownEntityType;
}

interface LabelledValues {
    labels: string[];
    values: KnownValue[];
}

/** Values grouped by the deduped labels of the sources that reported them, in first-appearance order. */
const partitionBySources = (group: KnownSourceGroup): LabelledValues[] => {
    const ownLabel = labelFor(group);
    const partitions = new Map<string, LabelledValues>();
    (group.values ?? []).forEach((value) => {
        const labels = [...new Set(value.sources?.length ? value.sources.map(({ label }) => label) : [ownLabel])];
        const key = labels.join(SOURCE_LABEL_SEPARATOR);
        const existing = partitions.get(key);
        if (existing) existing.values.push(value);
        else partitions.set(key, { labels, values: [value] });
    });
    return partitions.size ? [...partitions.values()] : [{ labels: [ownLabel], values: [] }];
};

const SourceGroupRow = ({ group, type, entityType }: SourceGroupRowProps) => (
    <>
        {partitionBySources(group).map(({ labels, values }) => {
            const label = labels.join(SOURCE_LABEL_SEPARATOR);
            return (
                <div key={`${group.sourceId}-${label}`} className={styles.SourceRow} data-testid={ALL_KNOWN_DETAILS_TESTIDS.SOURCE_ROW}>
                    <SourceValueRow
                        label={label}
                        subLabel={labels.length > 1 ? undefined : subLabelFor(group, entityType)}
                        values={values}
                        type={type}
                    />
                </div>
            );
        })}
    </>
);

export default SourceGroupRow;
